import { render, staticRenderFns } from "./AppScore.vue?vue&type=template&id=0ecce4fc&"
import script from "./AppScore.vue?vue&type=script&lang=js&"
export * from "./AppScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ecce4fc')) {
      api.createRecord('0ecce4fc', component.options)
    } else {
      api.reload('0ecce4fc', component.options)
    }
    module.hot.accept("./AppScore.vue?vue&type=template&id=0ecce4fc&", function () {
      api.rerender('0ecce4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/settings/src/components/AppList/AppScore.vue"
export default component.exports